import React from "react";
import { Box } from "../styledSystemUtilities";
import {
    AdvancedLinkRaw,
    CompetitiveAnalysisRaw,
    DynamicCallTrackingRaw,
    ExternalLinkRaw,
    FilterRaw,
    OptimizedLandingPageRaw,
    PenRaw,
    PrinterRaw,
    RawAdvancedSeo,
    RawAirplane,
    RawArt,
    RawCopyWriting,
    RawFacebook,
    RawGoogle,
    RawPhone,
    RawPhoto,
    RawResponsive,
    RawReviewsTracking,
    RawSeoContent,
    RawStrategy,
    ShippingRaw,
} from "./assets";
import { Text } from "./Text";
import theme from "../../theme";

export const Google = ({ name, fill }) => {
    return <IconTemplate name={name} Icon={RawGoogle} fill={fill} />;
};

export const Facebook = ({ name }) => {
    return <IconTemplate name={name} Icon={RawFacebook} />;
};

export const Responsive = ({ name }) => {
    return <IconTemplate name={name} Icon={RawResponsive} />;
};

export const Phone = ({ name }) => {
    return <IconTemplate name={name} Icon={RawPhone} />;
};

export const Art = ({ name }) => {
    return <IconTemplate Icon={RawArt} name={name} />;
};

export const CopyWriting = ({ name, fill }) => {
    return <IconTemplate name={name} Icon={RawCopyWriting} fill={fill} />;
};

export const Photo = ({ name }) => {
    return <IconTemplate Icon={RawPhoto} name={name} />;
};

export const Strategy = ({ name, fill }) => {
    return <IconTemplate Icon={RawStrategy} name={name} fill={fill} />;
};

export const AdvancedSeo = ({ name }) => {
    return <IconTemplate Icon={RawAdvancedSeo} name={name} />;
};

export const SeoContent = ({ name }) => {
    return <IconTemplate Icon={RawSeoContent} name={name} />;
};

export const Airplane = ({ name }) => {
    return <IconTemplate Icon={RawAirplane} name={name} />;
};

export const ReviewsTracking = ({ name, fill }) => {
    return <IconTemplate Icon={RawReviewsTracking} name={name} fill={fill} />;
};

export const CompetitiveAnalysis = ({ name }) => {
    return <IconTemplate Icon={CompetitiveAnalysisRaw} name={name} />;
};

export const ExternalLink = ({ name }) => {
    return <IconTemplate Icon={ExternalLinkRaw} name={name} />;
};

export const AdvancedLink = ({ name }) => {
    return <IconTemplate Icon={AdvancedLinkRaw} name={name} />;
};

export const DynamicCallTracking = ({ name }) => {
    return <IconTemplate Icon={DynamicCallTrackingRaw} name={name} />;
};

export const OptimizedLandingPage = ({ name }) => {
    return <IconTemplate Icon={OptimizedLandingPageRaw} name={name} />;
};

export const Filter = ({ name }) => {
    return <IconTemplate Icon={FilterRaw} name={name} />;
};

export const Pen = ({ name }) => {
    return <IconTemplate Icon={PenRaw} name={name} />;
};

export const Printer = ({ name }) => {
    return <IconTemplate Icon={PrinterRaw} name={name} />;
};

export const Shipping = ({ name }) => {
    return <IconTemplate Icon={ShippingRaw} name={name} />;
};

function IconTemplate({ Icon, name, fill }) {
    return (
        <Box height={"80px"} width={"98px"}>
            <Box height={"40px"} display={"flex"} alignItems={"flex-end"} pb={4}>
                <Icon fill={theme.colors[fill]} />
            </Box>

            <Text variant={"body4"} fontWeight={"medium"}>
                {name}
            </Text>
        </Box>
    );
}
